<template>
  <div class="service-page">
    <!-- 头部 -->
    <AppHeader />

    <!-- Banner -->
    <div class="banner" :style="{ backgroundImage: 'url(' + bannerImage + ')' }"></div>

    <!-- 悦享蛋糕卡 -->
    <section class="section cake-section">
      <div class="container">
        <div class="cake-wrapper">
          <div class="cake-image">
            <img src="//34188381.s21i.faiusr.com/2/ABUIABACGAAg9valzwYowoTfhgYwrQU4oQg.jpg" alt="悦享蛋糕卡">
          </div>
          <div class="cake-content">
            <h2 class="cake-title">悦享蛋糕卡</h2>
            <div class="cake-desc">
              <p>覆盖全国<span class="highlight-red">200+</span>品牌门店，支持兑换哈根达斯、星巴克、味多美、好利来、米卡米卡、诺心、壹点壹客、幸福西饼等<span class="highlight-red">优质蛋糕</span>，<span class="highlight-red">1000+</span>生日蛋糕线上兑，<span class="highlight-red">64+</span>电子券品牌。让企业关怀触手可及，大幅降低福利管理与沟通成本，简化发放流程，提升员工体验，让每一次福利发放都成为一次愉悦的体验，让关怀真正融入员工日常生活的每个场景，实现企业与员工的共赢共生。</p>
            </div>
            <div class="cake-features">
              <h3>产品特点</h3>
              <p>使用方式：储值类点卡，使用卡内点数兑换商城福利商品；</p>
              <p>功能属性：充值、查询、兑换、多卡合并支付等功能；</p>
            </div>
          </div>
        </div>
      </div>
    </section>


     <!-- 品类覆盖 -->
    <section class="section category-section">
      <div class="container">
        <div class="section-label">CATEGORY COVERAGE</div>
        <h2 class="section-heading">品类覆盖</h2>
        
        <div class="category-wrapper">
          <!-- 左侧大图 - 手机界面 -->
          <div class="category-phone">
            <img src="//34188381.s21i.faiusr.com/4/ABUIABAEGAAgwb6szwYogI0fMIAEOPYH!600x600.png" alt="品类覆盖">
          </div>
          
          <!-- 右侧4个分类卡片 -->
          <div class="category-cards">
            <div class="category-card">
              <img src="//34188381.s21i.faiusr.com/4/ABUIABAEGAAgntKszwYo0LmUBTDIATjIAQ.png" alt="生日蛋糕">
              <div class="category-card-info">
                <h4 class="category-card-title">生日蛋糕</h4>
                <p class="category-card-desc">支持兑换优质蛋糕</p>
              </div>
            </div>
            <div class="category-card">
              <img src="//34188381.s21i.faiusr.com/4/ABUIABAEGAAgq9KszwYosuTk0QYwyAE4yAE.png" alt="自助点餐">
              <div class="category-card-info">
                <h4 class="category-card-title">自助点餐</h4>
                <p class="category-card-desc">美食多选，系统订餐更省心<br>多家知名连锁餐饮品牌直签<br>覆盖线上线下用餐全场景</p>
              </div>
            </div>
            <div class="category-card">
              <img src="//34188381.s21i.faiusr.com/4/ABUIABAEGAAgstSszwYo1u2FnAEwyAE4yAE.png" alt="饮品直充">
              <div class="category-card-info">
                <h4 class="category-card-title">饮品直充</h4>
                <p class="category-card-desc">兑换代金券在对应点单品台上使用</p>
              </div>
            </div>
            <div class="category-card">
              <img src="//34188381.s21i.faiusr.com/4/ABUIABAEGAAgwY_8zwYo--3EjAMwyAE4yAE.png" alt="电子券">
              <div class="category-card-info">
                <h4 class="category-card-title">电子券</h4>
                <p class="category-card-desc">到店可作为现金抵扣使用</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- 臻选品牌 -->
    <section class="section brand-section">
      <div class="container">
        <div class="section-label">PREFERRED BRAND</div>
        <h2 class="section-heading">臻选品牌</h2>
        <div class="brand-logos">
          <img src="../src/assets/dgg.png" alt="臻选品牌">
        </div>
      </div>
    </section>

   
<ComsPross />
    <!-- 福利卡使用流程 -->
    <!-- <section class="section process-section">
      <div class="container">
        <div class="section-label">USING PROCESSES</div>
        <h2 class="section-heading">福利卡使用流程</h2>
        
        <div class="process-steps">
          <div class="process-item">
            <div class="process-card">
              <img class="process-icon" src="../src/assets/1.png" alt="关注公众号">
            </div>
            <div class="process-name">关注公众号</div>
            <div class="process-desc">关注微信公众号"悦享聚汇"，选择【悦享蛋糕】板块</div>
          </div>
          <div class="process-arrow">›</div>
          <div class="process-item">
            <div class="process-card">
              <img class="process-icon" src="../src/assets/2.png" alt="进入悦享蛋糕">
            </div>
            <div class="process-name">进入悦享蛋糕</div>
            <div class="process-desc">进入悦享蛋糕登陆账号，选择福利卡进行绑定</div>
          </div>
          <div class="process-arrow">›</div>
          <div class="process-item">
            <div class="process-card">
              <img class="process-icon" src="../src/assets/3.png" alt="绑定福利卡">
            </div>
            <div class="process-name">绑定福利卡</div>
            <div class="process-desc">输入卡号、密码或扫描二维码完成蛋糕卡的绑定</div>
          </div>
          <div class="process-arrow">›</div>
          <div class="process-item">
            <div class="process-card">
              <img class="process-icon" src="../src/assets/4.png" alt="选择心仪商品">
            </div>
            <div class="process-name">选择心仪商品</div>
            <div class="process-desc">选择商品加入购物车进行下单，可通过我的订单查询信息</div>
          </div>
        </div>
      </div>
    </section> -->

    <!-- 底部 -->
    <AppFooter />
  </div>
</template>

<script>
import AppHeader from '@/components/head.vue'
import AppFooter from '@/components/foot.vue'

import ComsPross from '@/components/coms1.vue';
export default {
  name: 'Service',
  components: {
    AppHeader,
    AppFooter,ComsPross
  },
  data () {
    return {
      bannerImage: require('../src/assets/dg.png'),
      footerNavItems: ['关于我们', '福利优选', '年节礼包', '生日卡券', '电影演出', '悦动态']
    }
  }
}
</script>

<style scoped>
* { margin: 0; padding: 0; box-sizing: border-box; }
body { font-family: 'Microsoft YaHei', 'PingFang SC', sans-serif; color: #353535; line-height: 1.6; }

.service-page { background: #fff; }

.banner {
  height: 800px;
  background-size: cover;
  background-position: 50% 50%;
}

.section { padding: 60px 0; }
.container { max-width: 1200px; margin: 0 auto; padding: 0 20px; }
.section-label { text-align: center; color: #e5e5e5; font-size: 36px; font-weight: bold; }
.section-heading { text-align: center; color: #353535; font-size: 36px; font-weight: bold; margin-bottom: 50px; }

/* 悦享蛋糕卡 */
.cake-wrapper { display: flex; gap: 30px; align-items: center; }
.cake-image { flex: 0 0 205px; }
.cake-image img { width: 200px; border-radius: 4px; }
.cake-content { text-align: left; flex: 1; min-width: 0; }
.cake-title { font-size: 28px; color: #353535; margin-bottom: 10px; }
.cake-desc { font-size: 20px; line-height: 2em; color: #666; margin-bottom: 0px; }
.highlight-red { color: #FF1212; font-weight: bold; }
.cake-features { font-size: 20px; line-height: 2em; color: #666; }
.cake-features h3 { font-size: 20px; color: #353535; margin-bottom: 0px; }

/* 品类覆盖 */
.category-wrapper {
  display: flex;
  gap: 30px;
  align-items: flex-start;
}
.category-phone {
  flex: 0 0 300px;
}
.category-phone img {
  width: 100%;
  border-radius: 8px;
}
.category-cards {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 30px;
  flex: 1;
  min-width: 0;
}
.category-card {
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.category-card img {
  width: 180px;
  height: 180px;
  margin-bottom: 20px;
}
.category-card-info {
  width: 100%;
  max-width: 250px;
}
.category-card-title {
  font-size: 16px;
  font-weight: bold;
  color: #333;
  margin-bottom: 10px;
}
.category-card-desc {
  font-size: 14px;
  color: #636363;
  line-height: 1.8;
  word-break: break-word;
}

/* 臻选品牌 */
.brand-logos { text-align: center; }
.brand-logos img { max-width: 100%; height: auto; }

/* 福利卡使用流程 */
.process-steps { 
  display: flex; 
  align-items: flex-start; 
  justify-content: center; 
  gap: 0; 
  margin-top: 50px; 
}
.process-item { 
  text-align: center; 
  width: 25%; 
  display: flex;
  flex-direction: column;
  align-items: center;
}
.process-card { 
  width: 125px; 
  height: 125px; 
  margin: 0 auto 30px; 
}
.process-icon { 
  width: 100%; 
  height: 100%; 
  object-fit: contain;
}
.process-name { 
  font-size: 16px; 
  font-weight: bold; 
  color: #000; 
  margin-bottom: 10px; 
}
.process-desc { 
  font-size: 14px; 
  color: #666; 
  line-height: 1.6;
  padding: 0 50px;
  word-break: break-word;
  width: 100%;
}
.process-arrow { 
  font-size: 32px; 
  color: #ccc; 
  margin-top: 50px; 
  flex-shrink: 0; 
}

/* 底部导航 */
.footer-nav-section { background: #2c2c2c; padding: 60px 0; }
.footer-nav-wrapper { display: grid; grid-template-columns: 274px 1fr 80px; gap: 60px; align-items: start; }
.footer-nav-title { color: #fff; font-size: 14px; margin-bottom: 20px; }
.footer-nav-list { list-style: none; line-height: 48px; }
.footer-nav-list li { color: rgba(255, 255, 255, 0.69); font-size: 14px; cursor: pointer; }
.footer-contact-info { color: #c6c6c6; font-size: 14px; line-height: 48px; }
.footer-qr { width: 49px; height: 50px; margin-top: 43px; cursor: pointer; }

/* ========== 响应式设计 ========== */
@media (max-width: 1024px) {
  .banner {
    height: 500px;
  }
  
  .section {
    padding: 40px 0;
  }
  
  .section-label {
    font-size: 24px;
  }
  
  .section-heading {
    font-size: 24px;
    margin-bottom: 30px;
  }
  
  .cake-wrapper {
    flex-direction: column;
    align-items: center;
  }
  
  .cake-image {
    flex: none;
    margin-bottom: 20px;
  }
  
  .cake-content {
    text-align: center;
  }
  
  .cake-desc {
    font-size: 16px;
    line-height: 1.8;
  }
  
  .cake-features {
    /* font-size: 16px; */
    text-align: left;
  }
  
  .category-wrapper {
    flex-direction: column;
    align-items: center;
  }
  
  .category-phone {
    flex: none;
    max-width: 300px;
    margin: 0 auto 30px;
  }
  
  .category-cards {
    grid-template-columns: 1fr 1fr;
    gap: 20px;
  }
  
  .category-card img {
    width: 120px;
    height: 120px;
  }
}

@media (max-width: 768px) {
  .banner {
    height: 300px;
  }
  
  .section {
    padding: 30px 0;
  }
  
  .section-label {
    font-size: 20px;
  }
  
  .section-heading {
    font-size: 22px;
    margin-bottom: 25px;
  }
  
  .cake-wrapper {
    flex-direction: column;
    align-items: center;
  }
  
  .cake-image {
    flex: none;
    margin-bottom: 20px;
  }
  
  .cake-image img {
    width: 150px;
  }
  
  .cake-content {
    text-align: center;
  }
  
  .cake-desc {
    font-size: 14px;
    line-height: 1.6;
  }
  
  .cake-features {
    /* font-size: 14px; */
    text-align: left;
    padding: 0 10px;
  }
  
  .category-wrapper {
    flex-direction: column;
    align-items: center;
  }
  
  .category-phone {
    flex: none;
    max-width: 250px;
    margin: 0 auto 25px;
  }
  
  .category-cards {
    grid-template-columns: 1fr;
    gap: 20px;
    width: 100%;
    max-width: 400px;
    margin: 0 auto;
  }
  
  .category-card {
    flex-direction: row;
    align-items: center;
    gap: 15px;
    text-align: left;
    padding: 10px;
    background: #f9f9f9;
    border-radius: 8px;
  }
  
  .category-card img {
    width: 80px;
    height: 80px;
    margin-bottom: 0;
    flex-shrink: 0;
  }
  
  .category-card-info {
    max-width: none;
  }
  
  .category-card-title {
    font-size: 14px;
    margin-bottom: 5px;
  }
  
  .category-card-desc {
    font-size: 12px;
    line-height: 1.5;
  }
  
  /* 流程步骤移动端优化 */
  .process-steps {
    flex-direction: column;
    align-items: center;
    gap: 15px;
  }
  
  .process-item {
    width: 100%;
    max-width: 300px;
    flex-direction: row;
    align-items: center;
    gap: 15px;
    text-align: left;
  }
  
  .process-card {
    width: 80px;
    height: 80px;
    margin: 0;
    flex-shrink: 0;
  }
  
  .process-name {
    font-size: 14px;
    margin-bottom: 5px;
  }
  
  .process-desc {
    font-size: 12px;
    padding: 0;
  }
  
  .process-arrow {
    transform: rotate(90deg);
    margin: 0;
    font-size: 24px;
  }
  
  .footer-nav-wrapper {
    grid-template-columns: 1fr;
    gap: 30px;
  }
}
</style>


// WEBPACK FOOTER //
// src/Service.vue